module.exports = __webpack_public_path__ + "static/media/Members.36caed28.svg";